import React from 'react';
import { observer } from '../../shared/observer';

// Кнопка-переключатель города в шапке. Клик открывает <CityBranchDialog>.
// Скрыта если у компании один филиал.
class CityBranchButtonView extends React.Component {
  render() {
    const auth = this.props.auth;
    const branches = auth.cityBranches || [];
    if (branches.length < 2) return null;
    const current = auth.cityBranch;
    const title = (current && current.title) || 'Город';
    return (
      <a
        href="#"
        className="ng-header__city"
        onClick={(e) => {
          e.preventDefault();
          auth.setCityBranchDialogOpen(true);
        }}
      >
        {title}
      </a>
    );
  }
}

export const CityBranchButton = observer(CityBranchButtonView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/CityBranch/CityBranchButton.jsx